import Layout from './components/layout';
import CompanyDetail from './components/CompanyDetail'
export default {
	Layout, CompanyDetail
}